export const newsList = [
  {
    id: "n01",
    title: "《锦岁长安》收官战报出炉：三条叙事线如何拧成一股绳",
    category: "剧集资讯",
    date: "2026-10-14",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20editorial%20still%20life%20of%20ancient%20chinese%20palace%20corridor%20with%20warm%20lantern%20light%20and%20misty%20atmosphere%2C%20deep%20indigo%20and%20amber%20tones%2C%20artistic%20moody%20film%20poster%20aesthetic%20with%20soft%20grain%2C%20no%20people%20no%20text%2C%20elegant%20composition&width=800&height=500&seq=news-01-cover&orientation=landscape",
    summary: "从群像铺陈到情感收束，编剧用三线并行的结构把一部古装剧的野心收得稳稳当当。",
    workId: "w11"
  },
  {
    id: "n02",
    title: "《逆流黎明》点映口碑炸裂，科幻外壳下藏着最朴素的情感",
    category: "电影资讯",
    date: "2026-10-13",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20cityscape%20at%20dawn%20with%20tall%20glass%20towers%20and%20soft%20indigo%20mist%2C%20distant%20warm%20lights%2C%20artistic%20moody%20film%20poster%20aesthetic%20with%20gentle%20grain%2C%20no%20people%20no%20text%2C%20wide%20composition&width=800&height=500&seq=news-02-cover&orientation=landscape",
    summary: "当科幻设定不再服务于奇观，而是服务于一次和解，观众才真正被打动。",
    workId: "w03"
  },
  {
    id: "n03",
    title: "《深海的信》导演专访：我想拍的不是悬疑，是等待",
    category: "主创专访",
    date: "2026-10-12",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20still%20of%20deep%20ocean%20surface%20with%20moonlight%20reflection%20and%20a%20small%20lighthouse%20silhouette%2C%20moody%20blue%20indigo%20tones%20with%20soft%20warm%20highlight%2C%20artistic%20film%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=800&height=500&seq=news-03-cover&orientation=landscape",
    summary: "悬疑只是引子，真正让这部剧立住的，是那些始终没等到回信的人。",
    workId: "w13"
  },
  {
    id: "n04",
    title: "从《我们的十年》看群像剧的“时间去哪儿了”",
    category: "行业观察",
    date: "2026-10-11",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20still%20life%20of%20a%20nostalgic%20old%20city%20street%20with%20warm%20sunset%20light%20and%20long%20shadows%2C%20amber%20and%20soft%20indigo%20tones%2C%20artistic%20film%20aesthetic%20with%20gentle%20grain%2C%20no%20people%20no%20text&width=800&height=500&seq=news-04-cover&orientation=landscape",
    summary: "十年跨度最难的不是化妆，是让观众相信角色真的变了。",
    workId: "w15"
  },
  {
    id: "n05",
    title: "网络剧《悬案笔记》为何能被观众逐帧分析？",
    category: "剧情解析",
    date: "2026-10-10",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20still%20of%20a%20rainy%20night%20city%20alley%20with%20neon%20reflections%20on%20wet%20ground%2C%20dark%20indigo%20tones%20with%20amber%20accents%2C%20artistic%20mystery%20film%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=800&height=500&seq=news-05-cover&orientation=landscape",
    summary: "每一处道具都不是闲笔，这才是悬疑剧该有的密度。",
    workId: "w29"
  },
  {
    id: "n06",
    title: "《雪落无声》重映定档，一段被低估的爱情被重新看见",
    category: "电影资讯",
    date: "2026-10-09",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20still%20of%20a%20snowy%20empty%20road%20flanked%20by%20bare%20trees%20under%20soft%20overcast%20light%2C%20cool%20indigo%20tones%20with%20quiet%20warmth%2C%20artistic%20film%20poster%20aesthetic%20with%20gentle%20grain%2C%20no%20people%20no%20text&width=800&height=500&seq=news-06-cover&orientation=landscape",
    summary: "好的爱情片从不说“我爱你”，它只让你看见有人一直没走。",
    workId: "w02"
  }
];